import { z } from 'zod'
import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zBackgroundColor,
  zBoxGapInGroup,
  zBoxMaxWidth,
  zBoxPlotStyle,
  zColor,
  zCrosshairRect,
  zDataset,
  zDimensionLinkage,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zMeasures,
  zOutlierStyle,
  zSort,
  zSortLegend,
  zTheme,
  zTooltip,
  zBrush,
  zWhiskersConfig,
  zXBandAxis,
  zYLinearAxis,
  zPage,
} from '../../properties'

export const zBoxPlot = z.object({
  chartType: z.literal('boxPlot'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  xAxis: zXBandAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  sort: zSort.nullish(),
  sortLegent: zSortLegend.nullish(),
  crosshairRect: zCrosshairRect.nullish(),
  boxPlotStyle: z.array(zBoxPlotStyle).or(zBoxPlotStyle).nullish(),
  outlierStyle: z.array(zOutlierStyle).or(zOutlierStyle).nullish(),
  theme: zTheme.nullish(),
  whiskers: zWhiskersConfig.nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  dimensionLinkage: zDimensionLinkage.nullish(),
  locale: zLocale.nullish(),
  boxMaxWidth: zBoxMaxWidth.nullish(),
  boxGapInGroup: zBoxGapInGroup.nullish(),
})
